import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Dialog } from '@material-ui/core';
import { GreenCheckMarkIcon } from 'assets/icons';
import confetti from 'canvas-confetti';
import { t } from 'i18next';
import DialogCard from 'shared/components/dialog/dialogCard';
import { State } from 'shared/interface';
import { isLoggedin } from 'shared/util/utility';
import { BetslipEvents, setDataLayer } from '../../constants/datalayer';

const WinningConfettiDialog = () => {
	const winData = useSelector<State, any>((state) => state.login.slipsWin);
	const [isShowPopup, setIsShowPopup] = useState(false);

	useEffect(() => {
		winData > 0 ? setIsShowPopup(true) : setIsShowPopup(false);
	}, [winData]);

	const duration = 2 * 1000;
	const animationEnd = Date.now() + duration;
	const defaults = {
		startVelocity: 15,
		spread: 360,
		ticks: 50,
		zIndex: 1400,
		colors: ['#00a267', '#004f39', '#eebc1d', '#f2d705', '#789885', '#ffed5f'],
	};

	const randomInRange = (min: number, max: number) => {
		return Math.random() * (max - min) + min;
	};

	if (isLoggedin() && isShowPopup) {
		const interval: any = setInterval(() => {
			const timeLeft = animationEnd - Date.now();

			if (timeLeft <= 0) {
				return clearInterval(interval);
			}

			const particleCount = 50 * (timeLeft / duration);
			// since particles fall down, start a bit higher than random
			confetti(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } }));
			confetti(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } }));
		}, 250);

		return (
			<>
				<Dialog
					maxWidth={'xs'}
					fullWidth
					onClose={() => {}}
					className={`custom-dialog bg--transparent custom--box-shadow text--center`}
					aria-labelledby="customized-dialog"
					open={true}
				>
					<DialogCard
						icon={() => <GreenCheckMarkIcon className="modal--icon lock--icon" />}
						className="success--card"
						iconTitle={t('winningDialogTitle')}
						title={`${winData?.toFixed(2).toString()}`}
						showAmount={true}
						cardBottomText={t('ok')}
						onActionButtonClick={() => {
							setDataLayer(BetslipEvents.BET_WIN(winData?.toFixed(2).toString()));
							setIsShowPopup(false);
						}}
					/>
				</Dialog>
			</>
		);
	} else return null;
};

export default WinningConfettiDialog;
